/* Generated file. Do not modify. Please check more details in build/generate.ts */
import * as React from "react";
import type { IconProps } from "../IconTypes";
import { IconWrapper } from "../IconWrapper";
export function ChevronRightIcon(props: IconProps) {
    return <IconWrapper {...props}>{<path d="M27.579 19.406c.561.625.561 1.563 0 2.125l-11.988 12c-.624.625-1.56.625-2.123 0a1.37 1.37 0 0 1 0-2.062L24.394 20.53l-10.926-11a1.37 1.37 0 0 1 0-2.062 1.366 1.366 0 0 1 2.06 0z"/>}</IconWrapper>;
}
